import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconKey3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKey3"><Circle cx="16.5" cy="7.5" r="5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.50105 16.2139L10.1587 17.8715L7.77239 20.2578L6.0625 18.5479" stroke="currentColor" strokeLinecap="square"/><Path d="M13 11.25L3.5 20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconKey3;
